/* eslint-disable @typescript-eslint/no-explicit-any */
import { enums } from "@shared/constants";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import ButtonRadio from "@ui-kit/form/ButtonRadio/ButtonRadio.web";
import CurrencyFormat from "@ui-kit/data-display/CurrencyFormat/CurrencyFormat.web";
import { useRadioGroup } from "@shared/hooks/useRadioGroup";
import React, { useEffect, useMemo } from "react";
import { CustomPriceOptionsProps } from "./CustomPriceOptions.props";

const CustomPriceOptions = (props: CustomPriceOptionsProps) => {
  const {
    price,
    options,
    defaultOption,
    onChange,
    currency = enums.CURRENCY_MAP.CAD.id,
    isCustomOption,
  } = props;

  const sortedPriceOptions = useMemo(() => {
    return Array.from(new Set(options)) // Remove duplicates
      .sort((a, b) => Number(a) - Number(b));
  }, [options]);

  const { getRadioProps, clearSelection } = useRadioGroup({
    name: "price",
    defaultValue: defaultOption,
    onChange,
  });

  /** if price is not from the option list, then uncheck all options */
  useEffect(() => {
    if (isCustomOption) {
      clearSelection();
    }
  }, [isCustomOption, clearSelection]);

  const priceOptions = sortedPriceOptions.map((option) => {
    const radio = getRadioProps({ value: option });

    if (price && !isCustomOption) radio.isChecked = radio.value === price;

    return (
      <Flex
        key={option}
        width="100%"
        flex="1 1 80px"
        height={{ base: "auto", xs: "element.3xl" }}
      >
        <ButtonRadio
          {...(radio as any)}
          labelProps={{ flexGrow: 1 }}
          data-testid={`custom-price-option-${option}`}
          width="100%"
          colorPalette="primary"
        >
          <CurrencyFormat
            value={option}
            displayType="text"
            currency={currency}
          />
        </ButtonRadio>
      </Flex>
    );
  });

  return <>{priceOptions}</>;
};

export default CustomPriceOptions;
